<template>
  <donut-chart-card
    title="사업장 현황"
    :value="data"
    unit="개소"
    :isMoveWrite="isMoveWrite"
    @detail="onClickDetail"
    @write="onClickWrite"
    @item="onClickItem"
  ></donut-chart-card>
</template>

<script>
import DonutChartCard from '@/components/DonutChartCard'

export default {
  name: 'DonutChart01',
  components: {DonutChartCard},
  props: {
    dataType: 'detail' | 'field' | 'company' | 'project',
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    }
  },
  watch: {
    dataType (/*value*/) {
      this.loadGraph()
    }
  },
  data () {
    return {
      graphId: 1,
      isMoveWrite: false,
      data: [{label: 'label', value: 0}],
    }
  },
  async mounted () {
    await this.loadGraph()
  },
  methods: {
    async loadGraph () {
      if (this.projectId) {
        await this.loadGraphCompany()
      } else {
        await this.loadGraphFieldType()
      }
    },
    async loadGraphFieldType () {
      const data = await this.$store.dispatch('summary/LOAD_SUMMARY_FIELD', {})
      const keys = Object.keys(data)
      if (keys && keys.length > 0) {
        const list = keys.map((value) => {
          return {label: this.changeFieldType(value), value: data[value].total}
        })

        list.sort((a, b) => {
          if (a.value > b.value) return -1
          else if (a.value < b.value) return 1
          else return 0
        })
        // console.log('hahaha', list);

        this.data = list
      }
    },
    changeFieldType(fieldType) {
      switch (fieldType) {
      case '사업장(용역위탁)':
        return '도급·용역·위탁사업 분야';
      case '사업장(도급발주)':
        return '도급사업 분야'
      case '시설물':
        return '시설물관리 분야';
      default:
        return fieldType;
      }
    },
    async loadGraphCompany () {
      const projectId = this.projectId
      const data = await this.$store.dispatch('summary/LOAD_SUMMARY_FIELD_COMPANY', {projectId})
      if (data && data.length > 0) {
        this.data = data.map((value) => {
          return {label: value.info.com_name, value: value.count}
        })
      }
    },
    onClickDetail () {
      const projectId = this.$route.params.proj_id
      const graphId = this.graphId
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`)
      } else {
        this.$router.push(`/graph-detail/${graphId}`)
      }
    },
    onClickWrite () {
      const proj_id = this.$route.params.proj_id
      this.$router.push({name: 'field-workplace-create', params: {proj_id}})
    },
    onClickItem () {
      if (Number(`${this.projectId}`) === 2) {
        this.$router.push('/project/1/field/info/type-a')
      } else if (Number(`${this.projectId}`) === 3) {
        this.$router.push('/project/1/field/info/type-b')
      } else if (Number(`${this.projectId}`) === 4) {
        this.$router.push('/project/1/field/info/type-c')
      } else if (Number(`${this.projectId}`) === 5) {
        this.$router.push('/project/1/field/info/type-d')
      }
    }
  },
}
</script>

<style scoped>

</style>
